import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa'


export default [
  {


    instagram: {
      name: 'instagram',
      url: 'https://www.instagram.com/',
      icon: <FaInstagram className="nav-icon" />,
    },



    facebook: {
      name: 'facebook',
      url: 'https://www.facebook.com/',
      icon: <FaFacebook className="nav-icon" />,
    },



    twitter: {
      name: 'twitter',
      url: 'https://www.twitter.com/',
      icon: <FaTwitter className="nav-icon" />,
    },

  }

]